import root from "window-or-global";
import type {ClientConfig} from "@atg-shared/client-config-types";

export const getClientConfig: () => ClientConfig = () => root.clientConfig;
